import { ICountryAsset, ICountryAssetLite } from "models/Assets/ICountryAsset";


const defaultFields = [
  "id",
  "abbreviation",
  "facebook_url",
  "twitter_url",
  "phone_code",
  "instagram_url",
  "icon",
  "phone_size_min",
  "phone_size_max",
  "default_currency",
  "payment_contact",
  "currencies",
  "contact_info",
];

const fields_ar = [...defaultFields, "currency_ar", "name_arabic"];

const fields_en = [...defaultFields, "currency_en", "name_english"];

export const toLiteCountry =
  (lang = null) =>
  (country: ICountryAsset): ICountryAssetLite => {
    const object = {};
    (lang === "en" ? fields_en : fields_ar).forEach((field) => {
      object[field] = country?.[field];
    });
    return object as ICountryAssetLite;
  };

export const toLiteCountries =
  (lang = null) =>
  (countries: ICountryAsset[]): ICountryAssetLite[] => {
    return countries.map(toLiteCountry(lang));
  };
